// // Default editor options
export const defaultOptions = {
  holder: 'editor-js',
  placeholder: 'Enter a Value',
  inlineToolbar: true,
  minHeight: 66,
  logLevel: 'ERROR',
};

export const emptyState = (data) => {
  return {
    time: Date.now(),
    blocks: [
      {
        id: 'tRdqCNhpfS',
        type: 'paragraph',
        data: {
          text: data,
        },
      },
    ],
    version: '2.25.0',
  };
};

export const isValidEditorData = (str) => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

export const validateEditorData = (value) =>
  value
    ? isValidEditorData(value)
      ? JSON.parse(value)
      : emptyState(value)
    : null;

export const isDataExist = (subject) => {
  return subject.hasOwnProperty('blocks') && subject.blocks.length;
};

export const getReadyStatusPromise = (subject) =>
  subject.hasOwnProperty('isReady') && subject.isReady;
export const getEditorSaveDataPromise = (subject) =>
  subject.hasOwnProperty('save') && subject.save();

export const getMultipleEditorsData = async (subjects) => {
  try {
    await Promise.all(
      subjects.map((subject) => getReadyStatusPromise(subject))
    );

    const editorData = await Promise.all(
      subjects.map((subject) => getEditorSaveDataPromise(subject))
    );

    return editorData;
  } catch (error) {
    console.error(error);
  }
};
